var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "only-stroke",
    d: "M9.28098 6.15345L11.3249 5.47213C11.9453 5.26534 12.2555 5.16195 12.4192 5.32568C12.583 5.48942 12.4796 5.7996 12.2727 6.41997L11.5914 8.46389C11.239 9.52103 11.0628 10.0496 10.6838 10.4287C10.3047 10.8077 9.77616 10.9839 8.71902 11.3363L6.6751 12.0176C6.05473 12.2244 5.74455 12.3278 5.58081 12.1641C5.41707 12.0004 5.52047 11.6901 5.72726 11.0698L6.40857 9.02585C6.76095 7.96871 6.93714 7.44014 7.3162 7.06107C7.69527 6.68202 8.22384 6.50583 9.28098 6.15345Z",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99945 8.74487L8.99561 8.74871",
    stroke: "#141B34",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "only-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3501 8.74485C2.3501 5.61001 2.3501 4.04259 3.32397 3.06872C4.29784 2.09485 5.86526 2.09485 9.0001 2.09485C12.1349 2.09485 13.7023 2.09485 14.6763 3.06872C15.6501 4.04259 15.6501 5.61001 15.6501 8.74485C15.6501 11.8797 15.6501 13.4471 14.6763 14.421C13.7023 15.3948 12.1349 15.3948 9.0001 15.3948C5.86526 15.3948 4.29784 15.3948 3.32397 14.421C2.3501 13.4471 2.3501 11.8797 2.3501 8.74485Z",
    stroke: "#141B34",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "only-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.62c913637634df3d6d632e5b1c705f47.svg";
export { ForwardRef as ReactComponent };